export default __webpack_public_path__ + "media/LandingOgBackground.443c531d687cdddbe4208cfb042fdbfb.webp";